export default {
  id: 'id',
  dateOfBirth: 'date-of-birth',
  firstName: 'first-name',
  lastName: 'last-name',
  gender: 'gender',
}
